import { AppLayout } from '../components/AppLayout';
import { UserRoute } from '../components/ProtectedRoute';

export default [UserRoute, AppLayout];
